import ne, { STORAGE_KEYS as t } from "../managers/storage-manager.js";
export function isDisabled() {
  return !!new ne.ne(null, !0).gr(t.ae);
}
